import React from 'react';
import { Create, ListButton, TopToolbar, useNotify } from 'react-admin';
import EmployeeForm from './EmployeeForm';

import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { errors, thereWasProblem } from '../../Utils/messages';

const EmployeeActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const EmployeeCreate = (props) => {
  const notify = useNotify();

  const onFailure = (error) => {
    const code = error.body.data.errorCode;
    notify(
      `${thereWasProblem}: ${
        errors[code] || 'Hubo un error con su solicitud, inténtelo mas tarde...'
      }`,
      'warning'
    );
  };

  return (
    <Create
      actions={<EmployeeActions {...props} />}
      onFailure={onFailure}
      {...props}
    >
      <EmployeeForm />
    </Create>
  );
};

export default EmployeeCreate;
